// src/index.js - Updated with PWA Integration

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import "@radix-ui/themes/styles.css";
import { Theme } from '@radix-ui/themes';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Import PWA initializer - this will handle service worker registration
import { PWAInitializer } from './utils/pwaInitializer';

// Create root
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render app
root.render(
  <BrowserRouter>
    <Theme>
      <App />
    </Theme>
  </BrowserRouter>
);

// Initialize PWA features after app starts
// The PWAInitializer will automatically register the service worker
// and handle all PWA functionality including config synchronization

// Optional: Listen for PWA events in your app
window.addEventListener('pwa-installable', (event) => {
  console.log('PWA can be installed', event.detail);
  // You can show an install button here
});

window.addEventListener('app-update-available', () => {
  console.log('App update available');
  // You can show an update notification here
});

window.addEventListener('notification-clicked', (event) => {
  console.log('Notification was clicked', event.detail);
  // Handle notification clicks in your app
});

window.addEventListener('background-sync', (event) => {
  console.log('Background sync occurred', event.detail);
  // Handle background sync in your app
});

// Report web vitals
reportWebVitals();